import { Flex, Form, Input, Select } from 'antd';
import dayjs from 'dayjs';
import { t } from 'i18next';

import {
  useIndicatorAnalyzeFilters,
  useIndicatorAnalyzeFiltersFormName,
} from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters';
import { INDICATOR_GROUP_BY_TYPES } from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters/types';
import { PreselectTemporalSelectInput } from 'ui/form/preselect-date-select-input';

export const MobileIndicatorAnalyzeFilters = () => {
  const formName = useIndicatorAnalyzeFiltersFormName();
  const [form] = Form.useForm();

  const filters = useIndicatorAnalyzeFilters();

  return (
    <Flex wrap>
      <Form layout="inline" form={form} name={formName} initialValues={filters}>
        <Form.Item name="filterType" hidden>
          <Input disabled />
        </Form.Item>
        <Form.Item name="dateRange" label={t('input.ringRange.label')}>
          <PreselectTemporalSelectInput mode="date" defaultDate={dayjs()} />
        </Form.Item>

        <Form.Item
          name="groupByType"
          label={t('reportAnalyze.indicatorAnalyze.groupByOptions')}
          style={{ minWidth: '110px' }}
        >
          <Select
            popupMatchSelectWidth={false}
            options={INDICATOR_GROUP_BY_TYPES.map((value) => ({
              label: t(`reportAnalyze.indicatorAnalyze.groupByOptions`, {
                context: value,
              }),
              value,
            }))}
          />
        </Form.Item>
      </Form>
    </Flex>
  );
};
